export interface IUserProfile {
    personalInfo: IPersonalInfo,
    studentInfo: IStudentInfo,
    vunetId: string
}

export interface IPersonalInfo {
    firstname: string,
    callName: string,
    dateOfBirth: string,
    displayName: string,
    lastName: string
}

export interface IStudentInfo {
    studentNumber: string,
    emailAddresses: IEmailAddress[],
    studies: IStudy[],
    emergencyContactDetails: IIce,
    addresses: IAddress[],
    disabilities: IDisability[],
    phoneNumbers: IPhoneNumber[]
}

export interface IIce {
    phoneNumbers: IPhoneNumber[]
}

export class IIcePost {
    constructor(
        public phoneNumbers: IPhoneNumberPost[]
    ){}
}

export interface IEmailAddress {
    emailAddress: string,
    isUniversityEmail: boolean
}

export interface IStudy {
    studyName: string,
    facultyName: string
}

export interface IPhoneNumber {
    number: string,
    countryIsoCode: string
}

export class IPhoneNumberPost {
    constructor(
        public number: string,
        public countryIsoCode: string
    ){}
}

export interface IDisability {
    id: string,
    description: string,
    otherDescription: string
}

export interface IAddress {
    street: string,
    houseNumber: string,
    houseNumberExtension: string,
    zipcode: string,
    city: string,
    country: ICountry,
    type: string,
    validFrom: string,
    validTo: string
}

export class IAddressPost {
    constructor(
        public street: string,
        public houseNumber: string,
        public houseNumberExtension: string,
        public zipcode: string,
        public city: string,
        public country: ICountryPost,
        public type: string,
    ){}
}

export interface ICountry {
    isoCode: string,
    name: string
}

export class ICountryPost {
    constructor(
        public isoCode: string
    ){}
}
